'use client';

import { useMemo, useState } from 'react';

export default function TemplateChecklist({ title = 'You can download and use the following documents as templates', items = [], onChange }) {
  const [local, setLocal] = useState(items);

  useMemo(() => {
    setLocal(items);
  }, [items]);

  const toggle = (id) => {
    setLocal((prev) => {
      const next = prev.map((it) => (it?.id === id ? { ...it, checked: !it?.checked } : it));
      onChange?.(next);
      return next;
    });
  };

  return (
    <div className="w-full max-w-md">
      <p className="text-xs font-semibold text-text-100 dark:text-white mb-2">{title}</p>

      <ul>
        {local.map((it) => (
          <li key={it?.id}>
            <label className={['flex items-start gap-2 rounded-md px-2 py-1', it?.disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer hover:bg-gray-50 dark:hover:bg-[#f3f3f31a]'].join(' ')}>
              <input type="checkbox" className="mt-1 accent-[#1F8022]" checked={!!it?.checked} disabled={!!it?.disabled} onChange={() => (it?.onChange ? it?.onChange() : toggle(it?.id))} />
              <span className="text-xs leading-5 text-[#225874] select-none">{it?.label}</span>
            </label>
          </li>
        ))}
      </ul>
    </div>
  );
}
